import { render, staticRenderFns } from "./RoomPlaceListItem.vue?vue&type=template&id=5cd30b58&"
import script from "./RoomPlaceListItem.vue?vue&type=script&lang=js&"
export * from "./RoomPlaceListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports